import { useState } from 'react';
import { STARTER_TEMPLATES } from '../../store/types.ts';
import { analytics } from '../../lib/analytics';

type OnboardingFlowProps = {
  open: boolean;
  onFinish: (templateId: string) => void;
  onSkip: () => void;
};

export function OnboardingFlow({
  open,
  onFinish,
  onSkip,
}: OnboardingFlowProps) {
  const [selectedTemplateId, setSelectedTemplateId] = useState(STARTER_TEMPLATES[0].id);

  if (!open) return null;

  return (
    <div className="ds-modal-overlay" role="dialog" aria-modal="true" aria-label="Welcome">
      <div className="ds-modal">
        <div className="ds-modal__head">
          <h3 className="ds-modal__title">Welcome to Sketchflow</h3>
          <button
            type="button"
            className="ds-btn ds-btn--sm ds-btn--ghost"
            onClick={() => {
              analytics.onboardingSkipped();
              onSkip();
            }}
          >
            Skip
          </button>
        </div>

        <div className="ds-onboarding__body">
          <h4>Pick a starter to jump right in</h4>
          <p>Select a template and we'll set up your first diagram instantly.</p>
          <div className="ds-template-grid">
            {STARTER_TEMPLATES.map((template) => (
              <button
                key={template.id}
                type="button"
                className={`ds-template-btn ${template.id === selectedTemplateId ? 'ds-template-btn--active' : ''}`}
                onClick={() => setSelectedTemplateId(template.id)}
              >
                <strong>{template.label}</strong>
                <span>{template.prompt}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="ds-modal__actions">
          <button
            type="button"
            className="ds-btn ds-btn--ghost"
            onClick={() => {
              analytics.onboardingSkipped();
              onSkip();
            }}
          >
            Skip for now
          </button>
          <button
            type="button"
            className="ds-btn ds-btn--primary"
            onClick={() => {
              analytics.onboardingCompleted(selectedTemplateId);
              onFinish(selectedTemplateId);
            }}
          >
            Start creating
          </button>
        </div>
      </div>
    </div>
  );
}
